/**
 * Web Bluetooth API Detector
 */

export interface BluetoothResult {
  available: boolean;
}

export async function detectWebBluetooth(): Promise<BluetoothResult> {
  try {
    const bluetooth = (navigator as Navigator & { bluetooth?: unknown }).bluetooth;
    return {
      available: !!bluetooth,
    };
  } catch (error) {
    return {
      available: false,
    };
  }
}
